import { useTranslation } from 'react-i18next';

interface FooterProps {
    version: string;
    appName: string;
}
const year = new Date().getFullYear();
const Footer = ({ version, appName }: FooterProps) => {
    const { t } = useTranslation('common');

    return (
        <div className="p-6 text-center text-xs text-gray-400">{t('common:copyright', { year, version, appName })}</div>
    );
};

export default Footer;
